import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class AuthModel extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.loginModel = {
      request: this.buildActionName('request', 'login'),
      response: this.buildActionName('response', 'login'),
      error: this.buildActionName('error', 'login'),
    };
    this.loggedModel = {
      request: this.buildActionName('request', 'logged'),
      response: this.buildActionName('response', 'logged'),
      error: this.buildActionName('error', 'logged'),
    };
    this.logoutModel = {
      request: this.buildActionName('request', 'logout'),
      response: this.buildActionName('response', 'logout'),
      error: this.buildActionName('error', 'logout'),
    };

    this.initialState = {
      user: {
        name: '',
        username: '',
      },
      isLoading: false,
      isLogged: false,
      error: false,
      errorMessage: '',
      modules: [],
    };
  }

  login = ({ formData: body }) => asyncFn({
    body, url: '/rest/_user/login', method: 'POST', model: this.loginModel,
  })

  logged = (token = '') => asyncFn({
    body: { token }, url: '/rest/_user/logged', method: 'POST', model: this.loggedModel,
  })

  logout = () => asyncFn({
    url: '/rest/_user/logout', method: 'POST', model: this.logoutModel,
  })

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case this.loginModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.loginModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.loginModel.response:
        return {
          ...state,
          isLoading: false,
          isLogged: true,
          user: action.payload.user || {},
        };
      case this.loggedModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.loggedModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.loggedModel.response:
        return {
          ...state,
          isLoading: false,
          isLogged: !!action.payload.user,
          user: action.payload.user || {},
        };
      case this.logoutModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.logoutModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.logoutModel.response:
        return {
          ...state,
          isLoading: false,
          isLogged: false,
          user: {},
        };
      default:
        return state;
    }
  }
}

export default AuthModel;



// WEBPACK FOOTER //
// ./src/models/AuthModel.js